import styled from 'styled-components';

export const Collapsible = styled.div<{
	isOpen?: boolean;
}>`
	margin: 1rem 0 0;
	transition: all 0.3s ease-in;
	max-height: ${(props) => (props.isOpen === true ? '100000px' : '0px')};
	overflow-y: ${(props) => (props.isOpen === true ? 'visible' : 'hidden')};
`;
